import { Query } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';
import { QueryBusHandlers } from './query-bus.service';

export function QueryHandlerFor<TQuery extends Query<TResult>, TResult>(query: Constructor<TQuery>) {
    return (target: any) => {
        if (QueryBusHandlers.some(([type]) => type === query)) {
            throw new Error(`Query handler for "${query.constructor.name}" is already registered.`);
        }
        QueryBusHandlers.push([query, target]);
    };
}
